import { useFavoriteMedia } from '@bpm-web-app/swr-hooks';
import { DownloadAlbum, Media } from '@bpm-web-app/api-client';
import { useApiErrorHandler } from '@bpm-web-app/utils';

export const useFavoriteMultipleMedia = (library?: string) => {
    const { mutate: mutateFavoriteMedia } = useFavoriteMedia(library);
    const errorHandler = useApiErrorHandler();
    const addMultipleToFavorites = async (mediaIds: number[], isDownload: boolean) => {
        try {
            if (isDownload) {
                // TODO: add mutating download favorite media once the hooks are ready
                await DownloadAlbum.favoriteMultipleAlbums(mediaIds);
            } else {
                await mutateFavoriteMedia(Media.addMultipleMediaToFavorites(mediaIds));
            }
        } catch (error) {
            errorHandler({ error });
        }
    };

    return {
        addMultipleToFavorites,
    };
};

export default useFavoriteMultipleMedia;
